import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      orange: "#F39D30",
      navy: "#052036",
      cream: "#FCFFF7",
      green: "#66A182",
      dark: "#011627",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === "dark" ? "brand.navy" : "brand.cream",
        color: props.colorMode === "dark" ? "brand.cream" : "brand.dark",
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "bold",
      },
      variants: {
        solid: (props) => ({
          bg: props.colorMode === "dark" ? "brand.orange" : "brand.green",
          color: "brand.cream",
          _hover: {
            bg: props.colorMode === "dark" ? "brand.green" : "brand.orange",
          },
        }),
        outline: (props) => ({
          borderColor: props.colorMode === "dark" ? "brand.orange" : "brand.green",
          color: props.colorMode === "dark" ? "brand.orange" : "brand.green",
          _hover: {
            bg: props.colorMode === "dark" ? "brand.orange" : "brand.green",
            color: "brand.cream",
          },
        }),
      },
    },
  },
});

export default theme;